import "./BillingStateCard.css";

const BillingStateCard = ({
  variant = "empty",
  title,
  message,
  actionLabel,
  onAction,
}) => (
  <div
    className={`billing-state-card billing-state-card--${variant}`}
    role={variant === "error" ? "alert" : "status"}
  >
    <h3 className="billing-state-card__title">{title}</h3>
    {message ? <p className="billing-state-card__message">{message}</p> : null}
    {actionLabel ? (
      <button
        type="button"
        className="billing-state-card__action"
        onClick={onAction}
      >
        {actionLabel}
      </button>
    ) : null}
  </div>
);

export default BillingStateCard;
